<template>
  <div class="basic_image" :style="moduleStyle">
    <!-- 生成base64图片用，兼容html2canvas生成图片跨域空白问题，勿删 -->
    <canvas ref="headCanvas" style="position: absolute; height: 0; width: 0; opacity: 0"></canvas>
    <img
        ref="img"
         class="my-img cmp-inner"
         :src="base64Img|| src "
         :style="style"
         @error.once="error"
         v-if="base64Img || src ">
         <div
         v-else
         ref="img"
         class="my-img cmp-inner"
         :style="style"></div>
    <div ref="lottieWrapper" class="lottie-wrapper"></div>
    <!--    <img class="img-clip-border" src="@/assets/images/clip-border/star.svg" alt="">-->
    <borderSvg v-if="module.style['clip-path']" :style="borderStyle" :module="module"></borderSvg>
  </div>
</template>

<script type="text/javascript">
import borderSvg from './borderSvg'
export default {
  name: 'BasicImageIndex',
  components: {
    borderSvg
  },
  data() {
    return {
      base64Img: ''
    }
  },
  props: {
    module: {
      type: Object,
      default: null
    }
  },
  computed: {
    moduleStyle() {
      const style = {}
      if (this.module.style['border-radius']) {
        style['border-radius'] = this.module.style['border-radius'] + 'px'
      }
      return style
    },
    style() {
      const style = this.utils.getStyle(this.module.style)
      if (this.module.filterType || this.module.filterType === 0) {
        style.filter = this.utils.getFilterCss(this.module.filter)
      }

      style['objectFit'] = this.module.fit
      return style
    },
    borderStyle() {
      const dashMap = {
        shixian: '0',
        xuxian1: '3 3',
        xuxian2: '10 5'
      }
      return {
        'stroke': '#f00',
        'stroke-width': '4px',
        'stroke-dasharray': dashMap.xuxian2
      }
    },
    src() {
      const r = this.module.file.orikey || this.module.file.key || ''
      const src = this.utils.src_has_gif(r)
      if (src.indexOf('http') > -1) {
        this.ImageToBase64(src)
      }
      return src
    },
    isDynamicFilter() {
      const dynamicKeys = [23, 24, 25, 26]
      return dynamicKeys.includes(this.module.filterType)
    }
  },
  watch: {
    'module.filterType': {
      handler() {
        if (this.isDynamicFilter) {
          this.removeLottie()
          this.createLottie()
        } else {
          this.removeLottie()
        }
      },
      deep: true
    },
    'style.width'() {
      // this.module.new_edit = true;
    },
    'style.height'() {
      // this.module.new_edit = true;
    }
  },
  methods: {
    // 将网络图片转化为Base64
    ImageToBase64(url) {
      const vm = this
      // 一定要设置为let，不然图片不显示，下面解释↓
      const image = new Image()
      // 解决跨域问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.src = url
      // image.onload为异步加载
      image.onload = () => {
        var canvas = vm.$refs.headCanvas
        if (canvas) {
          var context = canvas.getContext('2d')
          canvas.width = image.width
          canvas.height = image.height
          context.drawImage(image, 0, 0, image.width, image.height)
          var dataurl = canvas.toDataURL('image/png')
          this.base64Img = dataurl
        }
      }
    },
    error(e) {
    //   const r = this.module.file.orikey || this.module.file.key || ''
    //   $(e.target).attr('src', r)
    },
    fixField() {
      if (!this.module.filter) {
        this.$set(this.module, 'filter', {
          'brightness': 0,
          'contrast': 0,
          'saturate': 0,
          'hueRotate': 0,
          'blur': 0
        })
        this.$set(this.module, 'filterType', 0)
      }
      if (!this.module.shadow) {
        this.$set(this.module, 'shadow', {
          x: 0,
          y: 0,
          blur: 0,
          color: '#000'
        })
      }
      if (!this.module.clipShape) {
        this.$set(this.module, 'clipShape', '')
      }
    },
    createLottie() {
    //   import( /* webpackChunkName: "lottie" */ 'lottie-web').then(lottie => {
    //     let filterConfig = filterList.find(item => item.type === this.module.filterType)
    //     lottie.loadAnimation({
    //       container: this.$refs.lottieWrapper,
    //       renderer: "svg",
    //       loop: true,
    //       autoplay: true,
    //       animationData: filterConfig.jsonPath,
    //       assetsPath: "https://staticjs.71360.com/static/suichuan/images/dynamicImg/"
    //       // assetsPath: "https://lib.eqh5.com/@eqxiu/editor-plugin/dynamicFilter/dynamicImg/"
    //     })
    //   })
    },
    removeLottie() {
      this.$refs.lottieWrapper.innerHTML = ''
    }
  },
  created() {
    this.fixField()
    const style = this.module.style
    if (typeof style['border-width'] === 'undefined') {
      style['border-width'] = 0
    }
  },
  mounted() {
    console.log(145, this.module)
    if (this.isDynamicFilter) {
    //   if ($(this.$el).parents('.page_list_wrapper').length) {
    //     // 左边的预览小图不显示，耗性能。
    //     return
    //   }
      this.createLottie()
    }
  }
}
</script>

<style lang="scss" scoped>
.basic_image {
  position: relative;
  font-size: 0;
  overflow: hidden;

  img {
    box-sizing: content-box;
  }

  .my-img {
    vertical-align: top;
    // object-fit: cover;
  }

  .new_edit {
    object-fit: cover;
  }

  .lottie-wrapper {
    position: absolute;
    width: 120%;
    height: 120%;
    top: -10%;
    left: -10%;
    overflow: hidden;
  }

  .clip-border-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
}
</style>
